module.exports = __webpack_public_path__ + "static/media/videoSlider.00509db4.mp4";